module.exports = __webpack_public_path__ + "static/media/fleetlocate-login-logo.4c13412c.png";